import React from "react";
import { NavLink } from "react-router-dom";
import { prefetchCategoryProducts } from "@/lib/categoryPrefetch";

const ITEMS = [
  { to: "/category/ethnic", label: "Kurtis", slug: "ethnic" },
  { to: "/category/coords", label: "Co-ords", slug: "coords" },
  { to: "/category/dresses", label: "Dresses", slug: "dresses" },
  { to: "/category/tops", label: "Tops", slug: "tops" },
];

const warm = (slug) => {
  if (slug) prefetchCategoryProducts(slug);
};

const MobileCategoryTabs = () => (
  <section className="lg:hidden border-b border-border bg-muted/40" data-testid="mobile-category-tabs">
    <div className="flex gap-2 overflow-x-auto no-scrollbar px-4 py-3">
      {ITEMS.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          onPointerEnter={() => warm(item.slug)}
          onPointerDown={() => warm(item.slug)}
          onFocus={() => warm(item.slug)}
          className={({ isActive }) =>
            `shrink-0 px-4 py-2.5 min-h-11 text-[10px] uppercase tracking-[0.2em] border transition-colors ${
              isActive
                ? "border-primary bg-primary text-primary-foreground"
                : "border-border bg-background text-primary"
            }`
          }
        >
          {item.label}
        </NavLink>
      ))}
    </div>
  </section>
);

export default MobileCategoryTabs;
